mutation FeedbackSubmit($input: FeedbackSubmitInput!) {
    feedbackSubmit(input: $input) {
        success
    }
}
